import { CharacterSkinsValues } from '../CharacterSpine';
import ChunkBase from './ChunkBase';
import EntitySmallGem from './entities/EntitySmallGem';
import EntitySmashableCrate from './entities/blockers/EntitySmashableCrate';
import EntitySmashableVine from './entities/blockers/EntitySmashableVine';
import EntitySmashableRocks from './entities/blockers/EntitySmashableRocks';
import { RelicName, RelicNameValues } from './relics/relic';
import RelicBronzeBoots from './relics/RelicBronzeBoots';
import RelicWings from './relics/RelicWings';
import RelicSkull from './relics/RelicSkull';
import RelicMagnet from './relics/RelicMagnet';
import RelicHelmet from './relics/RelicHelmet';
import EntityRelic from './EntityRelic';
import EntityMegaGem from './entities/EntityMegaGem';

export class EntityFactory {
  protected scene: Phaser.Scene;
  protected isInitialised: boolean;
  protected gemsGroup!: Phaser.GameObjects.Group;
  protected megaGemsGroup!: Phaser.GameObjects.Group;
  protected smashableCrateGroup!: Phaser.GameObjects.Group;
  protected smashableVineGroup!: Phaser.GameObjects.Group;
  protected smashableRocksGroup!: Phaser.GameObjects.Group;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.isInitialised = false;
  }

  public init() {
    // if (this.isInitialised) return;

    this.gemsGroup = this.scene.add.group([], {
      classType: EntitySmallGem,
      quantity: 20
    });

    this.megaGemsGroup = this.scene.add.group([], {
      classType: EntityMegaGem,
      quantity: 5
    });

    this.smashableCrateGroup = this.scene.add.group([], {
      classType: EntitySmashableCrate
    });

    this.smashableVineGroup = this.scene.add.group([], {
      classType: EntitySmashableVine
    });

    this.smashableRocksGroup = this.scene.add.group([], {
      classType: EntitySmashableRocks
    });

    // this.isInitialised = true;
  }

  public makeRelic(relicName: RelicNameValues, x: number, y: number): EntityRelic {
    switch (relicName) {
      case RelicName.BronzeBoots:
        let boots = new RelicBronzeBoots(this.scene, x, y);
        boots.init(relicName);
        return boots;
        case RelicName.GoldenWings:
          let wings = new RelicWings(this.scene, x, y);
          wings.init(relicName);
          return wings;
          case RelicName.SilverHelmet:
          let helmet = new RelicHelmet(this.scene, x, y);
          helmet.init(relicName);
          return helmet;
          case RelicName.PlatinumMagnet:
          let magnet = new RelicMagnet(this.scene, x, y);
          magnet.init(relicName);
          return magnet;
          case RelicName.DiamondSkull:
          let skull = new RelicSkull(this.scene, x, y);
          skull.init(relicName);
          return skull;
      default:
        let defaultRelic = new RelicBronzeBoots(this.scene, x, y);
        defaultRelic.init(relicName);
        return defaultRelic;
    }
  }

  public makeSmallGem(chunk: ChunkBase): EntitySmallGem {
    // console.log('Gems group size', this.gemsGroup.getLength());
    let gem = this.gemsGroup.get() as EntitySmallGem;
    gem.init();
    gem.bindChunk(chunk);
    gem.reset();

    // console.log('Gems group size post', this.gemsGroup.getLength());
    return gem;
  }

  public makeMegaGem(chunk: ChunkBase): EntityMegaGem {
    // console.log('Gems group size', this.gemsGroup.getLength());
    let gem = this.megaGemsGroup.get() as EntityMegaGem;
    gem.init();
    gem.bindChunk(chunk);
    gem.reset();

    // console.log('Gems group size post', this.gemsGroup.getLength());
    return gem;
  }

  public makeSmashableCrate(chunk: ChunkBase, allowedCharacter: CharacterSkinsValues): EntitySmashableCrate {
    let smashable = this.smashableCrateGroup.get() as EntitySmashableCrate;
    smashable.init();
    smashable.bindChunk(chunk);
    smashable.reset(allowedCharacter);
    return smashable;
  }

  public makeSmashableVine(chunk: ChunkBase, allowedCharacter: CharacterSkinsValues): EntitySmashableVine {
    let smashable = this.smashableVineGroup.get() as EntitySmashableVine;
    smashable.init();
    smashable.bindChunk(chunk);
    smashable.reset(allowedCharacter);
    return smashable;
  }

  public makeSmashableRocks(chunk: ChunkBase, allowedCharacter: CharacterSkinsValues): EntitySmashableRocks {
    let smashable = this.smashableRocksGroup.get() as EntitySmashableRocks;
    smashable.init();
    smashable.bindChunk(chunk);
    smashable.reset(allowedCharacter);
    return smashable;
  }
}
